// extracted by mini-css-extract-plugin
export default {"notif":"BillingNotif_notif__+TYTo","notifImage":"BillingNotif_notifImage__yPTtG","notifText":"BillingNotif_notifText__YRvey"};